import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Esito } from 'src/app/common/models/esito';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import {
  SezioneEconomicaLiquidatiFormComponent
} from '../../../form/sez-economica/sezione-economica-liquidati-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Liquidato } from '../../../models/liquidato';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';

@Component({
    selector: 'div [sezione-economica-liquidati-form-update]',
  templateUrl: '../../../form/sez-economica/sezione-economica-liquidati-form.component.html'
})

export class SezioneEconomicaLiquidatiUpdateComponent extends SezioneEconomicaLiquidatiFormComponent implements OnInit {
  private liquidato: Liquidato;
  private urlUpdate: string;
  private urlReadSezioneEconomica: string;

  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }


  ngOnInit() {
    this.isInserimento(false);
  }

  getLiquidato() {
    return this.liquidato;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }


  getRequest(sezioneEconomicaLiquidatiAdapter: Liquidato, esito: Esito) {
    esito.liquidati.push(sezioneEconomicaLiquidatiAdapter);
    this.operationService.updateLiquidati(this.urlUpdate, sezioneEconomicaLiquidatiAdapter, this.sezione ? this.sezione.id : 'new').subscribe((response: any) => this.datiSezioneEconomica(response));
  }

  datiSezioneEconomica(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }


  inizializza(sezione: SezioneEconomica, liquidato: Liquidato, fascicolo: FascicoloFull, urlUpdate: string, isViewTerzoPignorato: boolean, idSezioneEsiti, urlReadSezioneEsiti, esito: Esito) {
    this.liquidato = liquidato ? liquidato : new Liquidato();
    this.fascicolo = fascicolo;
    this.esito = esito;
    this.isViewTerzoPignorato = isViewTerzoPignorato;
    this.idSezioneEsiti = idSezioneEsiti;
    this.urlReadSezioneEsiti = urlReadSezioneEsiti;
    this.readSezioneEsiti(idSezioneEsiti, urlReadSezioneEsiti);
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.initViewToggle();
    this.populateSelect();
    this.createForm();
  }

}
